'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fad';
var iconName = 'balloons';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'e2e4';
var svgPathData = ['M294 335.3c5.8-7 11.7-14.4 17.3-22.2 24.1-33.1 48.2-76.8 54.9-126.6 7.1-11.2 19.6-18.6 33.8-18.6 13.3 0 24-10.7 24-24s-10.7-24-24-24c-12.3 0-24 2.5-34.6 7.1-2.7-17.2-7.6-33.8-14.3-49.3 19.8-8.8 41.8-13.7 64.9-13.7 88.4 0 160 71.6 160 160 0 112-128 208-128 208l27.9 41.8c2.7 4 4.1 8.8 4.1 13.6 0 13.6-11 24.6-24.6 24.6l-78.9 0c-13.6 0-24.6-11-24.6-24.6 0-4.8 1.4-9.6 4.1-13.6L384 432s-52.2-39.2-90-96.7z', 'M160 0c88.4 0 160 71.6 160 160 0 112-128 208-128 208l27.9 41.8c2.7 4 4.1 8.8 4.1 13.6 0 13.6-11 24.6-24.6 24.6l-78.9 0c-13.6 0-24.6-11-24.6-24.6 0-4.8 1.4-9.6 4.1-13.6L128 368S0 272 0 160C0 71.6 71.6 0 160 0zM104 144c0-22.1 17.9-40 40-40 13.3 0 24-10.7 24-24s-10.7-24-24-24c-48.6 0-88 39.4-88 88 0 13.3 10.7 24 24 24s24-10.7 24-24z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBalloons = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;